import { reducer as questionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { reducer as messages } from "@teamprevent/common/messaging/index";
import { reducer as questionnaires } from "@teamprevent/common/questionnaires/reducer";
import { reducer as referralForm } from "@teamprevent/common/questionnaires/components/referralForm/reducer";

import { reducer as currentUser } from "./auth";
import { reducer as customerUsers } from "./crud/customerUser";
import { reducer as ohCases } from "./crud/ohCase";
import { actionableTasks, actionableTask } from "./actionableTask/reducer";
import { reducer as dashboard } from "./dashboard";
import { reducer as ppqReports } from "./Ppq";
import { reducer as allowedProducts } from "./allowedProducts";
import { reducer as customerDocuments } from "./documents";
import { reducer as allowedPhysioOrigins } from "./allowedPhysioOrigins";
import { reducer as allowedCovid19Features } from "./allowedCovid19Features";
import { reducer as customerDetails } from "./customerDetails";
import { reducer as allowedAssessmentAndWellBeingFeatures } from "./allowedAssessmentAndWellBeingFeatures";
import { reducer as customerSraDepartments } from "./customerSraDepartments";
import { sraTasks, sraResults, teamSraResults } from "./assessmentAndWellBeing/reducer";
import { orgStructures } from "./orgStructure/reducer";
import { customMedicalTypes } from "./customMedicalTypes/reducer";

export const reducers = {
    currentUser,
    questionnaires,
    referralForm,
    customerUsers,
    ohCases,
    actionableTasks,
    actionableTask,
    dashboard,
    ppqReports,
    allowedProducts,
    questionnaireConfig,
    allowedPhysioOrigins,
    allowedCovid19Features,
    customerDetails,
    messages,
    customerDocuments,
    allowedAssessmentAndWellBeingFeatures,
    customerSraDepartments,
    sraTasks,
    sraResults,
    teamSraResults,
    orgStructures,
    customMedicalTypes
};
